import { forwardRef } from 'react';

import { IconProps } from '.';

export const YesNoIcon = forwardRef<SVGSVGElement, IconProps>(({ className, size = 20, ...props }, ref) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" ref={ref} {...props} {...{ className }}>
      <path
        d="M10 3.5C8.71442 3.5 7.45772 3.88122 6.3888 4.59545C5.31988 5.30968 4.48676 6.32484 3.99479 7.51256C3.50282 8.70028 3.37409 10.0072 3.6249 11.2681C3.8757 12.529 4.49477 13.6872 5.40381 14.5962C6.31285 15.5052 7.47104 16.1243 8.73192 16.3751C9.99279 16.6259 11.2997 16.4972 12.4874 16.0052C13.6752 15.5132 14.6903 14.6801 15.4046 13.6112C16.1188 12.5423 16.5 11.2856 16.5 10C16.5 9.14641 16.3319 8.30117 16.0052 7.51256C15.6786 6.72394 15.1998 6.00739 14.5962 5.40381C13.9926 4.80022 13.2761 4.32144 12.4874 3.99478C11.6988 3.66813 10.8536 3.5 10 3.5ZM5 10C5 8.67392 5.52679 7.40215 6.46447 6.46447C7.40215 5.52678 8.67392 5 10 5V15C8.67392 15 7.40215 14.4732 6.46447 13.5355C5.52679 12.5979 5 11.3261 5 10Z"
        fill="currentColor"
      />
    </svg>
  );
});

export default YesNoIcon;
